export function normalizeRuntimeVariable(value = '') {
  return String(value).trim().replace(/^@/, '').replace(/#[A-Z]$/i, '').toUpperCase();
}

export function appendVariableTrace(values, variable, detail = {}) {
  const name = normalizeRuntimeVariable(variable);
  if (!name || !values || typeof values !== 'object') return values;

  const trace = Array.isArray(values.__SST_VARIABLE_TRACE) ? values.__SST_VARIABLE_TRACE : [];
  values.__SST_VARIABLE_TRACE = [
    ...trace,
    {
      variable: name,
      type: detail.type || 'assignment',
      block: detail.block || '',
      sourceLine: detail.sourceLine ?? null,
      actionId: detail.actionId || '',
      value: detail.value ?? '',
      empty: detail.value === undefined || detail.value === null || String(detail.value) === '',
    },
  ].slice(-200);
  return values;
}

export function variableTraceFor(values, variable) {
  const name = normalizeRuntimeVariable(variable);
  return (Array.isArray(values?.__SST_VARIABLE_TRACE) ? values.__SST_VARIABLE_TRACE : [])
    .filter((entry) => normalizeRuntimeVariable(entry.variable) === name);
}


